export default {
  currentUser: {},
  currentCompany: 0,
  currentReports: {},
  currentReportName: '',
  qualityUpperLimit: 1.05,
  qualityLowerLimit: 0.95,
  statuses: [],
  workOrderStatus: [],
  picklistStatus: [],
  picklistUnits: [],
  workOrderUnit: [],
  workOrderResponsible: [],
  perPage: 50,
  selectedFlataRows: [],
  selectedFlata: [],
  selectedReportRows: {},
  routeData: {},
  nodeEnv: process.env.NODE_ENV,
  apiUrl: process.env.API_ENDPOINT
}



// WEBPACK FOOTER //
// ./src/store/state.js